import { Injectable, signal } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import {
  QuickLink,
  SidebarConfiguration,
} from '../../models/sidebar-configuration';

@Injectable({
  providedIn: 'root',
})
export class SidebarService {
  // Initialize signals with default values
  private cssClassesSignal = signal<string>('');
  private headerContentSignal = signal<string>('');
  private subtitleContentSignal = signal<string>('');
  private quickLinksSignal = signal<QuickLink[] | null>([]);
  private iconSignal = signal<string>('');
  private toolbarSizeSignal = signal<string>('');
  private contentSizeSignal = signal<string>('');
  private toolOverlayClassesSignal = signal<string>('');

  // Publicly expose read access to the signals
  readonly cssClasses$ = this.cssClassesSignal;
  readonly headerContent$ = this.headerContentSignal;
  readonly subtitleContent$ = this.subtitleContentSignal;
  readonly quickLinks$ = this.quickLinksSignal;
  readonly icon$ = this.iconSignal;
  readonly toolbarSize$ = this.toolbarSizeSignal;
  readonly contentSize$ = this.contentSizeSignal;
  readonly toolOverlayClasses$ = this.toolOverlayClassesSignal;

  setConfiguration(config: SidebarConfiguration) {
    // Update signals with new values
    this.cssClassesSignal.set(config.cssClasses ?? '');
    this.headerContentSignal.set(config.headerText ?? '');
    this.subtitleContentSignal.set(config.subtitle ?? '');
    this.iconSignal.set(config.icon ?? '');
    this.quickLinksSignal.set(
      config.quickLinks?.filter(link => !!link.visible) ?? null
    );
    this.setToolOverlayCssClass();
  }

  setToolbarSize(cssClass: string) {
    this.toolbarSizeSignal.set(cssClass ?? 'w-4rem');
    this.contentSizeSignal.set(cssClass === 'w-4rem' ? 'bigger' : 'smaller');
    this.setToolOverlayCssClass();
  }

  setToolOverlayCssClass() {
    this.toolOverlayClassesSignal.set(
      (this.cssClasses$() || '') + ' pl-' + (this.contentSize$() || '')
    );
  }
}
